// Re-export from canonical location: components/ui/v2/sidebar
export { default } from "components/ui/v2/sidebar/sidebar-menu-list";
